import React from 'react';
import Header from './Header/Header';
import Footer from './Footer/Footer';
import { Outlet } from 'react-router-dom';
import './Layout.css';
import FloatingContacts from '../common/FloatingContacts';

const Layout = () => {
    return (
        <div className="site-wrapper">
            <Header />
            <main className="main-content">
                <Outlet />
            </main>
            <Footer />
            <FloatingContacts />
        </div>
    );
};

export default Layout;
